import React, {SVGAttributes} from 'react';

export function ArrowRight(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 25"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.66586 20.9098L8.25586 19.4998L15.2559 12.4998L8.25586 5.49984L9.66586 4.08984L18.0759 12.4998L9.66586 20.9098Z"
                fill={props.fill}
            />
        </svg>
    );
}
